import {Badge} from "./dto/com.rico.sb2.service";
import {apiGetForAjaxResponse} from "./lib/SecuredAjax";
import {AppConfig} from "./AppConfig";

export interface AppAjaxOperations {
	opPositionBadges(): Promise<Badge[]>;

	opTransportBadges(): Promise<Badge[]>;
}

export class AppAjax implements AppAjaxOperations {
	static delegate: AppAjaxOperations = new AppAjax();

	static get operations(): AppAjaxOperations {
		return AppAjax.delegate;
	}

	static set operations(delegate: AppAjaxOperations) {
		AppAjax.delegate = delegate;
	}

	opPositionBadges(): Promise<Badge[]> {
		return apiGetForAjaxResponse(`${AppConfig.CP}/op/positionBadges`);
	}

	opTransportBadges(): Promise<Badge[]> {
		return apiGetForAjaxResponse(`${AppConfig.CP}/op/transportBadges`);
	}
}
